export default "__VITE_ASSET__017da096__"